import { z } from 'zod';
import { metadata } from './helpers';
import { contentBase } from './content';

export const founderContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    title: z.string(),
    description: z.string(),
    badge: z.string(),
    location: z.string(),
    image: z.string(),
    attorney_id: z.number().int().positive(),
  }),
});

export const contentTypeFounderContentSchema = contentBase.extend({
  content: founderContentSchema,
});

export type ContentTypeFounderContentInput = z.infer<typeof contentTypeFounderContentSchema>;
